export default require("../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js");